import { Component, Input, OnInit } from '@angular/core';
import { IContentElementTemplate } from './model';
import { ElementType, IContentElement, QuestionState } from '../models';

@Component({
  selector: 'element-render-template',
  templateUrl: './element-render-template.component.html',
  styleUrls: ['./element-render-template.component.scss']
})
export class ElementRenderTemplateComponent implements OnInit {

  @Input() element:IContentElementTemplate;
  @Input() isLocked:boolean;
  @Input() isShowSolution:boolean;
  @Input() questionState:QuestionState;
  @Input() changeCounter:number;

  constructor(
    
  ) { }

  ngOnInit(): void {
  }

  getFontScale(element:IContentElement){
    let fontScale = 1;
    return fontScale;
  }

  getElementStyle(element:IContentElement){
    const fontScale = this.getFontScale(element);
    const style = {
      'font-size': fontScale+'em',
    }
    return style
  }

}
